var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"politica"},[_vm._v(" Отправляя заявку, Вы соглашаетесь на обработку "),_c('a',{attrs:{"href":_vm.$store.state.form.politica.val,"target":_vm.$store.state.form.politica.target}},[_vm._v("персональных данных")])])}
var staticRenderFns = []

export { render, staticRenderFns }